import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";
import { BettingLimit, LimitPeriod, TimedBettingLimitParams } from "@obg/ngx.common";

import { LIMIT_PERIOD_VALUE } from "./betting-limit-change.const";

@Component({
	selector: "obg-m-betting-limit-change",
	templateUrl: "betting-limit-change.component.html",
	styleUrls: ["betting-limit-change.component.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BettingLimitChangeComponent {
	@HostBinding("class.obg-m-betting-limit-change") hostCssClass = true;

	isBiggerLimit = false;

	@Input()
	set currentLimit(value: BettingLimit | undefined) {
		this._currentLimit = value;

		if (value === undefined) {
			this.isBiggerLimit = false;
			return;
		}

		this.isBiggerLimit = this.isBigger(this._currentLimit, this._nextLimit);
	}

	get currentLimit() {
		return this._currentLimit;
	}

	@Input()
	set nextLimit(value: TimedBettingLimitParams | undefined) {
		this._nextLimit = value;

		if (value === undefined) {
			this.isBiggerLimit = true;
			return;
		}

		this.isBiggerLimit = this.isBigger(this._currentLimit, this._nextLimit);
	}

	get nextLimit() {
		return this._nextLimit;
	}

	private _currentLimit: BettingLimit | undefined;
	private _nextLimit: TimedBettingLimitParams | undefined;

	isBigger(currentLimit?: BettingLimit, nextLimit?: TimedBettingLimitParams) {
		if (currentLimit === undefined || currentLimit.limitPeriod === undefined) {
			return false;
		}

		if (nextLimit === undefined || nextLimit.period === undefined) {
			return true;
		}

		const currentDailyLimit = currentLimit.limitValue / LIMIT_PERIOD_VALUE[currentLimit.limitPeriod as LimitPeriod];
		const nextDailyLimit = nextLimit.limitValue / LIMIT_PERIOD_VALUE[nextLimit.period as LimitPeriod];

		return nextDailyLimit > currentDailyLimit;
	}
}
